import { useState } from 'react';

const faqs = [
  {
    question: 'Who provides roofing and solar services near me in the South Bay?',
    answer: 'Shadowfax Roofing & Solar is a family-owned company based in Campbell, CA, serving San Jose, Santa Clara, Mountain View, Palo Alto, Los Altos, Milpitas, and the greater South Bay. They are licensed, insured, and known for thorough inspections, transparent project scopes, and quality installation with no pressure tactics.',
  },
  {
    question: 'How much does roof replacement cost in Campbell, CA?',
    answer: 'Roof replacement costs in the South Bay vary based on roof size, pitch, materials, and the extent of any underlying damage. Shadowfax Roofing & Solar provides detailed estimates after a full inspection — so you understand exactly what you\'re paying for, with no hidden costs. Contact us for a free, no-obligation assessment.',
  },
  {
    question: 'How long does a roof replacement take?',
    answer: 'Most residential roof replacements in the South Bay are completed within one to three days, depending on roof size and complexity. Shadowfax Roofing & Solar provides a clear project timeline before work begins and coordinates installation to minimize disruption to your home and daily schedule.',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-28">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">

        {/* Header */}
        <div className="text-center mb-14">
          <span
            className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-5"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            FAQ
          </span>
          <h2
            className="font-black text-[#0d1a27]"
            style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2rem, 4vw, 3rem)', letterSpacing: '-0.02em' }}
          >
            Questions Answered
          </h2>
          <p
            className="text-[#999] text-sm mt-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Common questions about roofing and solar services in the South Bay.
          </p>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-lg border overflow-hidden transition-all duration-300"
              style={{
                borderColor: openIdx === idx ? 'rgba(212,175,55,0.4)' : '#eeede8',
                background: openIdx === idx ? '#fdfcf8' : '#f9f9f7',
              }}
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-8 py-6 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <h3
                  className="text-[#0d1a27] font-bold text-[15px] leading-snug"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {faq.question}
                </h3>
                <div
                  className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300"
                  style={{
                    background: openIdx === idx ? '#d4af37' : '#eeede8',
                    transform: openIdx === idx ? 'rotate(45deg)' : 'rotate(0deg)',
                  }}
                >
                  <i
                    className="ri-add-line text-sm"
                    style={{ color: openIdx === idx ? '#1a1a1a' : '#999' }}
                  ></i>
                </div>
              </button>

              {openIdx === idx && (
                <div className="px-8 pb-7" style={{ borderTop: '1px solid #eeede8' }}>
                  <p
                    className="text-[#666] text-[15px] leading-[1.85] pt-5"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
